<style>
  .status-circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: inline-block;
  }

  .status-green {
    background-color: #28c76f;
  }

  .status-red {
    background-color: #ea5455;
  }

  .status-grey {
    background-color: #c2c2c2;
  }

  .status-yellow {
    background-color: #ff9f43;
  }
</style>
<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th>Action</vs-th>
        <vs-th sort-key="">Sales ID/Name</vs-th>
        <vs-th sort-key="">Session</vs-th>
        <vs-th sort-key="">Cash In Transit</vs-th>
        <vs-th sort-key="">Handover Document</vs-th>
        <vs-th sort-key="">Daily Closing</vs-th>
        <vs-th sort-key="">Exception</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-input-group flex">
              <vs-button
                @click.stop="handleExceptionAction(data[indextr])"
                size="small"
                color="primary"
                icon-pack="feather"
                icon="icon-edit"
                title="Exception Request"
                style="margin-right: 5px"
              />
              <vs-button v-if="data[indextr].exception_status == 'Open'" size="small" color="primary" icon-pack="feather" icon="icon-check" title="Approval"
                style="margin-right: 5px" @click="handleSendApproval(data[indextr].exception_id)" />
            </div>
          </vs-td>
          <vs-td :data="data[indextr].sales_name">
            {{ data[indextr].sales_name }}
          </vs-td>
          <vs-td>
            <div>Start Session : {{ data[indextr].in_time | formatDateSession }}</div>
            <div class="flex items-center">
              <span
                class="status-circle"
                :class="getSessionStatusColor(data[indextr])"
              ></span>

              <span style="margin-left:6px;">
                End Session : {{ data[indextr].out_time | formatDateSession }}
              </span>
            </div>
          </vs-td>
          <vs-td>
            <div class="flex items-center">
              <span
                class="status-circle"
                :class="getCITStatusColor(data[indextr])"
              ></span>

              <span style="margin-left:6px; cursor:pointer; color:blue;"
              @click="handleShowCITDetails(data[indextr])">
                CIT Complete : {{ data[indextr].cit_released }} of {{ data[indextr].cit_total }} <br>
                Released At : {{ data[indextr].cit_complete | formatDate }}
              </span>
            </div>
          </vs-td>
          <vs-td>
            <div class="flex items-center">
              <span
                class="status-circle"
                :class="getHandoverStatusColor(data[indextr])"
              ></span>

              <span style="margin-left:6px; cursor:pointer; color:blue;"
              @click="handleShowHandoverDetails(data[indextr])">
                Handover Document Complete : {{ data[indextr].handover_released }} of {{ data[indextr].handover_total }} <br>
                Released At : {{ data[indextr].handover_complete | formatDate }}
              </span>
            </div>
          </vs-td>
          <vs-td>
            <div class="flex items-center">
              <span
                class="status-circle"
                :class="getDailyStatusColor(data[indextr])"
              ></span>

              <span style="margin-left:6px;">
                Daily Closing Complete : {{ getDailyClosingComplete(data[indextr]) | formatDateDailyClosing }}
              </span>
            </div>
          </vs-td>
          <vs-td>
            <div class="flex items-center">
              <span style="margin-left:6px;">
                Code : {{ data[indextr].exception_code }} <br>
                Last Updated At : {{ data[indextr].exception_updated_at | formatDateSession }} <br>
                Status : {{ getExceptionStatus(data[indextr]) }} 
              </span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-popup title="CIT Details" :active.sync="showCITPopup">
      <div v-if="selectedCITDetails.length > 0">
        <div v-for="(item, index) in selectedCITDetails" :key="index" style="margin-bottom:10px;">
          <div><b>Code:</b> {{ item.code }}</div>
          <div><b>Released At:</b> {{ item.released_at | formatDate }}</div>
          <vs-divider />
        </div>
      </div>

      <div v-else>
        No data available
      </div>
    </vs-popup>
    <vs-popup title="Handover Details" :active.sync="showHandoverPopup">
      <div v-if="Object.keys(groupedHandoverDetails).length">
        <div
          v-for="(items, code) in groupedHandoverDetails"
          :key="code"
          style="margin-bottom:20px;"
        >
          <div>
            <b>Code:</b> {{ code }}
          </div>
          <div>
            <b>Handover At:</b>
            {{ items[0].handover_at | formatDate }}
          </div>
          <vs-table :data="items">
            <template slot="thead">
              <vs-th>Invoice Code</vs-th>
              <vs-th>Handover Status</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr
                v-for="(row, index) in data"
                :key="index"
              >
                <vs-td>
                  {{ row.invoice_code }}
                </vs-td>
                <vs-td>
                  {{ row.handover_status ? 'YES' : 'NO' }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-divider />
        </div>
      </div>
      <div v-else>
        No data available
      </div>
    </vs-popup>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import moment from "moment";
import { CalendarIcon } from "vue-feather-icons";
export default {
  components: {},
  props: {
    baseUrl: {
      type: String,
    },
    detail: {
      type: Boolean,
    },
    territoryID: {
      type: Number,
    },
    salesSupervisorID: {
      type: Number,
    },
    salesID: {
      type: Number,
    },
    dateStart: {
      type: String,
    },
    draw: {
      type: Number,
    },
    isGetData: {
        type: Boolean,
    },
  },
  data() {
    return {
      deleteId: null,
      confirmId: null,
      table: this.tableDefaultState(),
      itemDel: 0,
      exportID: [],
      showingData: true,
      selectAll: false,
      IDItem: [],
      showCITPopup: false,
      selectedCITDetails: [],
      showHandoverPopup: false,
      selectedHandoverDetails: []
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 0;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.$emit("close");
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl + "/get-data", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            territory_id: this.territoryID ? this.territoryID : 0,
            sales_supervisor_id: this.salesSupervisorID ? this.salesSupervisorID : 0,
            sales_id: this.salesID ? this.salesID : 0,
            date: this.dateStart ? this.dateStart : "",
            ignore_matrix_approval: "true",
          },
        })
        .then((resp) => {
          console.log("DATA", resp);
          if (resp.code == 200) {
            let records = resp.data.records || [];

            // GROUP BY personal_id
            const grouped = {};

            records.forEach((item) => {
              if (!grouped[item.personal_id]) {
                grouped[item.personal_id] = [];
              }
              grouped[item.personal_id].push(item);
            });

            // FILTER LOGIC
            let filteredData = [];

            Object.values(grouped).forEach((group) => {
              const hasNonRejected = group.some(
                (item) => item.exception_status !== "Daily Closing Rejected"
              );

              if (hasNonRejected) {
                // ambil semua yang bukan Rejected
                filteredData.push(
                  ...group.filter(
                    (item) => item.exception_status !== "Daily Closing Rejected"
                  )
                );
              } else {
                // kalau semua Rejected → tetap tampilkan
                const latestRejected = group.sort(
                  (a, b) =>
                    new Date(b.exception_updated_at) -
                    new Date(a.exception_updated_at)
                )[0];

                filteredData.push(latestRejected);
              }
            });

            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            // this.table.data = resp.data.records;
            this.table.data = filteredData;
            // for (let index = 0; index < resp.data.records.length; index++) {
            //   this.IDItem.push(resp.data.records[index].id);
            // }
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleEdit(id) {
      console.log("aaaaaaaaa", id);
      this.$router.push({
        name: "product-back-to-back-edit",
        params: { id: id },
      });
    },
    handleExceptionAction(row) {
      console.log("RESP ROW",row)
      if (!this.isAllowedException(row)) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Exception allowed only after End Session, when CIT is RED and Handover is RED or YELLOW.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return;
      }

      const hasException = row.exception_id && row.exception_id !== 0;

      if (hasException) {
        if (["Daily Closing Waiting Approval", "Daily Closing With Approval"].includes(row.exception_status)) {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "You already have an active exception request.",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          return;
        }

        if (row.exception_status !== "Daily Closing Rejected") {
          this.handleExceptionForm(row.exception_id);
          return;
        }
      }

      // jika belum ada exception
      this.handleException(row);
    },
    handleException(row) {
      this.$router.push({
        name: "salesman-exception",
        query: {
          personal_id: row.personal_id,
          personal_name: row.sales_name,
          territory_id: this.territoryID,
          exception_id: row.exception_id ? row.exception_id : 0,
          exception_code: row.exception_code ? row.exception_code : "",
          date: this.dateStart, 
        }
      });
    },
    handleExceptionForm(id) {
      this.$router.push({
        name: "salesman/exception",
        params: {
           id: id, 
        }
      });
    },
    handleSendApproval(id) {
        this.confirmId = id;
        if(this.confirmId == null || this.confirmId == 0){
            this.$vs.dialog({
                type: 'alert',
                color: 'danger',
                title: 'Information',
                text: 'Please fill in the input form first !',
                acceptText: 'OK',
            });
            throw new Error('BreakException');
        } else {
            this.$vs.dialog({
                type: "confirm",
                color: "warning",
                title: `Confirm`,
                text: "Send Approval this data",
                accept: this.acceptSendApproval,
            });
        }
    },
    acceptSendApproval() {
        this.$vs.loading();
        let param = {
            id: this.confirmId,
            status: 1
        };
        this.$http
            .post("/api/sfa/v1/daily-closing-salesman/change-status", param)
            .then((resp) => {
                this.$vs.loading.close();
                if (resp.code == 200) {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: "The data was successfully confirm",
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });
                } else {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                        duration: 10000,
                    });
                }
                this.getData();
            })
            .catch((error) => {
                this.$vs.loading.close();
                console.log(error);
            });
    },
    getSessionStatusColor(row) {
      const isValidTime = (val) => {
        return val && val !== "0001-01-01T00:00:00Z";
      };

      const hasOutTime = isValidTime(row.out_time);
      const hasInTime = isValidTime(row.in_time);

      const hasLat = row.out_latitude && row.out_latitude !== "";
      const hasLng = row.out_longitude && row.out_longitude !== "";

      // jika end session ada + lokasi ada
      if (hasOutTime && hasLat && hasLng) {
        return "status-green";
      }

      // jika end session ada tapi lokasi kosong
      if (hasOutTime && (!hasLat || !hasLng)) {
        return "status-yellow";
      }

      // jika start session ada tapi end session belum
      if (hasInTime && !hasOutTime) {
        return "status-red";
      }

      return "status-grey";
    },
    getCITStatusColor(row) {
      const isValidTime = (val) => {
        return val && val !== "0001-01-01T00:00:00Z";
      };

      const hasInTime = isValidTime(row.in_time);
      // jika sales belum melakukan start session, maka status cit akan berwarna abu-abu
      if (!hasInTime) {
        return "status-grey";
      }

      if (row.collection_plan_status == 'green') {
        return "status-green";
      }

      if (row.collection_plan_status == 'yellow') {
        return "status-yellow";
      }

      if (row.collection_plan_status == 'red') {
        return "status-red";
      }

      return "status-grey";
    },
    getHandoverStatusColor(row) {
      const isValidTime = (val) => {
        return val && val !== "0001-01-01T00:00:00Z";
      };

      const hasInTime = isValidTime(row.in_time);
      // jika sales belum melakukan start session, maka status handover akan berwarna abu-abu
      if (!hasInTime) {
        return "status-grey";
      }

      if (row.handover_status == 'green') {
        return "status-green";
      }

      if (row.handover_status == 'yellow') {
        return "status-yellow";
      }

      if (row.handover_status == 'red') {
        return "status-red";
      }

      return "status-grey";
    },
    getDailyStatusColor(row) {
      const isValidTime = (val) => {
        return val && val !== "0001-01-01T00:00:00Z";
      };

      const hasInTime = isValidTime(row.in_time);
      const hasOutTime = isValidTime(row.out_time);
      const hasLat = row.out_latitude && row.out_latitude !== "";
      const hasLng = row.out_longitude && row.out_longitude !== "";

      // jika daily closing selesai menggunakan exception
      if (row.exception_status == 'Daily Closing With Approval') {
        return "status-yellow";
      }

      // jika tidak ada aktivitas salesman
      if (!hasInTime && !hasOutTime) {
        return "status-grey";
      }

      // jika cit status warna merah, handover status warna merah dan kuning
      if (row.collection_plan_status == 'red' || row.handover_status == 'red' || row.handover_status == 'yellow') {
        return "status-red";
      }

      // jika daily closing selesai otomatis tanpa exception
      if (((hasOutTime && hasLat && hasLng) || (hasOutTime && (!hasLat || !hasLng))) && ['green', 'grey', 'yellow'].includes(row.collection_plan_status) && ['green', 'grey'].includes(row.handover_status)) {
        return "status-green";
      }

      return "status-grey";
    },
    getDailyClosingComplete(row) {
      const hasOutTime = row.out_time;
      const hasLat = row.out_latitude && row.out_latitude !== "";
      const hasLng = row.out_longitude && row.out_longitude !== "";

      if (row.exception_status === 'Daily Closing With Approval') {
        return row.exception_updated_at
      }

      if (((hasOutTime && hasLat && hasLng) || (hasOutTime && (!hasLat || !hasLng))) && ['green', 'grey', 'yellow'].includes(row.collection_plan_status) && ['green', 'grey'].includes(row.handover_status)) {
        if(row.handover_status == 'green'){
          return row.handover_complete
        } else {
          return row.out_time
        }
      }
      return "";
    },
    parseJSON(val) {
      try {
        return typeof val === 'string' ? JSON.parse(val) : val
      } catch (e) {
        return []
      }
    },
    handleShowCITDetails(row) {
      this.selectedCITDetails = this.parseJSON(row.cit_details)
      this.showCITPopup = true
    },
    handleShowHandoverDetails(row) {
      this.selectedHandoverDetails = this.parseJSON(row.handover_details)
      this.showHandoverPopup = true
    },
    isAllowedException(row) {
      const isValidTime = (val) => {
        return val && val !== "0001-01-01T00:00:00Z";
      };

      const hasOutTime = isValidTime(row.out_time);
      return (
        hasOutTime && (row.collection_plan_status === 'red' || row.handover_status === 'red' || row.handover_status === 'yellow')
      );
    },
    getExceptionStatus(row) {
      // jika daily closing otomatis berhasil
      if (this.getDailyStatusColor(row) === "status-green") {
        return "No Exception (Auto Daily Closing)";
      }

      return row.exception_status;
    },
  },
  filters: {
    formatDate(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value)
          .utcOffset(7 * 60)
          .format("YYYY-MM-DD HH:mm:ss");
      }
    },
    formatDateDailyClosing(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value)
          .utcOffset(7 * 60)
          .format("DD MMM YYYY HH:mm:ss");
      }
    },
    formatDateSession(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value)
          .add(-7, "h")
          .utc()
          .local()
          .format("YYYY-MM-DD HH:mm:ss");
      }
    },
  },
  watch: {
    draw() {
      this.getData();
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        if (this.isGetData){
          this.handleChangePage(val);
        }
      },
    },
    groupedHandoverDetails() {
      return this.selectedHandoverDetails.reduce((groups, item) => {
        if (!groups[item.code]) {
          groups[item.code] = [];
        }

        groups[item.code].push(item);
        return groups;
      }, {});
    }
  },
  mounted() {
    // this.getData();
  },
};
</script>
